// Add vm-prefix, because without prefix functions go into inifnite loop
// or recursive calling.
export const vmEncodeURI = (str) => encodeURI(str);
export const vmEncodeURIComponent = (str) => encodeURIComponent(str);
